import { Color } from '../common/color';

export class InterpolatedFeatureStyle {
    public Color: Color;
    public CurrentValue: number;
    public MinValue: number;
    public MaxValue: number;
    public MinOpacity: number;
    public MaxOpacity: number;
}